module.exports = __webpack_public_path__ + "static/media/logo.4eda5e6a.png";